import { decrypt } from "../../../../commons/utils/crypto";
/*
 * Called only on InApp redirect like in Linkedin because the window is open inside linkedin

 */
export default async function initAsInAppRedirect () {
    this.init();
    const sessionSettings = this.env.page.sessionSettings;
    const qParams = this.env.page.params
    const subscriberStore = this.env.subscriberStore;
    this.initWithSession(true);
    
    if (qParams.d && qParams.k) {
        const decrypted = await decrypt(qParams.d, qParams.k);
        console.log(` initAsInAppRedirect() -> decrypted ${decrypted}`);
    }

    const sess = {
        ...sessionSettings,
        translations: [],
    };

    console.log(` initAsInAppRedirect() -> sessionSettings ${JSON.stringify(sess, 0,4)}`);
    console.log(` initAsInAppRedirect() -> Page Params ${JSON.stringify(this.env.page.params, 0,4)}`);
   
    // make an oauthSession call with Session Id
    
    this.initializedAsInAppRedirect = true;
    this.kickstarted = true;
    this.hasLanguage = false;
    await this.env.languageStore.getTranslations();
    await this.getOptins();
    this.hasLanguage = false;
    await subscriberStore.oauthSession({
        sessionId: this.oauthSessionId,
    });
}
